import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { REFUND_METHOD } from 'domains/customer-refund/constants'
import StringUtil from 'utils/string-util'

const propTypes = {
  method: PropTypes.string
}

/**
 * @param {string} method
 */
const CustomerRefundMethodBadge = ({ method }) => {

  const colorMap = {
    [REFUND_METHOD.CASH]         : 'success',
    [REFUND_METHOD.CREDIT_CARD]  : 'info',
    [REFUND_METHOD.KREDIVO]      : 'warning',
    [REFUND_METHOD.GOPAY]        : 'warning',
    [REFUND_METHOD.VOUCHER_CODE] : 'primary'
  }

  const color = colorMap[method] || 'default'

  return <StatusBadge color={ color } label={ StringUtil.humanize(method) } />
}

CustomerRefundMethodBadge.propTypes = propTypes

export default CustomerRefundMethodBadge
